import { useSafetyTranslation } from 'cng-common/features/translations'
import { ModalDialog } from 'core-components/library/modalDialog'

import { NetworkDebugContent } from './NetworkDebugContent'
import { NETWORK_DEBUG_TRANSLATION_KEYS } from './translations'

import styles from './NetworkDebugDialog.module.scss'

const KEYS = NETWORK_DEBUG_TRANSLATION_KEYS

interface INetworkDebugDialogProps {
  show: boolean
  onClose: () => void
}

/** The Super Admin's window over this session's JBPSettings and planningCockpitGzip requests: the
 *  response as it came and the data after mapping, to tell a data problem from a UI one. */
export const NetworkDebugDialog = ({ show, onClose }: INetworkDebugDialogProps) => {
  const t = useSafetyTranslation()

  return (
    <ModalDialog
      size="xl"
      show={show}
      onClose={onClose}
      title={t(KEYS.title)}
      content={NetworkDebugContent}
      classes={{ window: styles.window, body: styles.body }}
    />
  )
}

NetworkDebugDialog.displayName = 'NetworkDebugDialog'
